export const DEFAULT_SEARCH_PLACEHOLDER = 'Start typing to search for items or perform an action'
